import {AirportApiServiceClient} from "../../proto/generated/api_entities_grpc_web_pb";
import {getProxyUrl} from "../helpers/getProxyUrl";
import {
  AirportApiAirportListRequest,
  AirportApiAirportListResponse, AirportApiGetAirportRequest, AirportApiGetAirportResponse,
  AirportApiGetExtendedAirportRequest, AirportApiGetExtendedAirportResponse,
  AirportApiGetAirportFromAviapagesRequest, AirportApiGetAirportFromAviapagesResponse,
} from "../../proto/generated/api_entities_pb";
import {API} from "../API";

const client = new AirportApiServiceClient(getProxyUrl(), null, null);

export class AirportApi {
  static async getAirportList(req: AirportApiAirportListRequest): Promise<AirportApiAirportListResponse> {
    return new Promise((resolve, reject) => {
      API.call<AirportApiAirportListRequest, AirportApiAirportListResponse>(client, client.airportList, req, resolve, reject)
    })
  }

  static async getAirportExtendedList(req: AirportApiGetExtendedAirportRequest): Promise<AirportApiGetExtendedAirportResponse> {
    return new Promise((resolve, reject) => {
      API.call<AirportApiGetExtendedAirportRequest, AirportApiGetExtendedAirportResponse>(client, client.airportExtended, req, resolve, reject)
    })
  }

  static async getAirportById(req: AirportApiGetAirportRequest): Promise<AirportApiGetAirportResponse> {
    return new Promise((resolve, reject) => {
      API.call<AirportApiGetAirportRequest, AirportApiGetAirportResponse>(client, client.airport, req, resolve, reject)
    })
  }

  static async getAirportFromAviapages(req: AirportApiGetAirportFromAviapagesRequest): Promise<AirportApiGetAirportFromAviapagesResponse> {
    return new Promise((resolve, reject) => {
      API.call<AirportApiGetAirportFromAviapagesRequest, AirportApiGetAirportFromAviapagesResponse>(client, client.airportFromAviapages, req, resolve, reject)
    })
  }
}